import { stripQueryFromUrl } from './strip-query-from-url';

/**
 * Minimal shape of a RUM event we mutate in `beforeSend`. Kept local so this
 * module does not need `@datadog/browser-rum` at test time; compatible with
 * `@servicetitan/datadog-rum`'s `ApplicationBeforeSendHandler`.
 */
interface RumBeforeSendEvent {
    type: string;
    resource?: { url: string };
    view?: { url?: unknown };
    error?: { resource?: { url?: unknown } };
}

/**
 * Privacy pass for Customer Portal RUM: strip query strings from view,
 * resource, and error resource URLs so identity params are never stored.
 */
export function beforeSend(event: RumBeforeSendEvent): void {
    if (event.type === 'resource' && event.resource) {
        event.resource.url = stripQueryFromUrl(event.resource.url);
    }

    if (event.view && typeof event.view.url === 'string') {
        event.view.url = stripQueryFromUrl(event.view.url);
    }

    const errorResource = event.error?.resource;
    if (errorResource && typeof errorResource.url === 'string') {
        errorResource.url = stripQueryFromUrl(errorResource.url);
    }
}
